import api from "../api";

export const register = async (payload) => {
  return api
    .post(`/v0/register`, payload)
    .then(({ data }) => data);
};

export const authenticate = async (payload) => {
  return api
    .post(`/v0/login`, payload)
    .then(({ data }) => data);
}

export const getUser = async () => {
  return api
    .get("/v0/user")
    .then(({ data }) => data)
}

export const updateUser = async (payload) => {
  return api
    .put("/v0/user", payload)
    .then(({ data }) => data)
}

export const getPermissions = async () => {
  return api
    .get("/v0/user/permissions")
    .then(({ data }) => data.data)
}

export const getPartner = async () => {
  return api
    .get("/v0/partner")
    .then(({ data }) => data)
}

export const updatePartner = async (payload) => {
  return api
    .put("/v0/partner", payload)
    .then(({ data }) => data)
}

export const confirmEmail = async (payload) => {
  return api
    .get(`/v0/email-confirmation/${payload.email}/${payload.code}`)
    .then(({ data }) => data);
}

export const resendConfirmationEmail = async (email) => {
  return api
    .get(`/v0/re-send-email-confirmation/${email}`)
    .then(({ data }) => data);
}

export const sendResetPasswordCode = async (email) => {
  return api
    .post(`/v0/reset-password/${email}`)
    .then(({ data }) => data);
}

export const resetPassword = async (payload) => {
  return api
    .post(`/v0/reset-password`, payload)
    .then(({ data }) => data);
}
